import 'css-chunksrc/client/common/reportIndicator/styles.scss';export default {};